// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_4f720283bf--wrapper--bF8JS","auto-prolong":"_4f720283bf--auto-prolong--k2ot8","hint":"_4f720283bf--hint--tnsmK"};